import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { ConsultasGeneralesContent } from './components/ConsultasGeneralesContent';

export default function ConsultasGenerales() {
  return (
    <>
      <MainContent
        titulo='Consultas Generales'
        component={<ConsultasGeneralesContent />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}